<ng-container *appI18nScopeReady>
  <h2 mat-dialog-title>{{ 'title' | i18n }}</h2>

  <mat-dialog-content>
    <div class="form">
      <mat-form-field appearance="outline">
        <mat-label>{{ 'name_label' | i18n }}</mat-label>
        <input
          matInput
          [(ngModel)]="name"
          [placeholder]="'name_placeholder' | i18n"
          (keydown.enter)="apply()"
        />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>{{ 'description_label' | i18n }}</mat-label>
        <textarea
          matInput
          [(ngModel)]="description"
          [placeholder]="'description_placeholder' | i18n"
          rows="3"
        ></textarea>
      </mat-form-field>

      <app-group-input
        [(value)]="group"
        [groups]="availableGroups"
        [label]="'group_label' | i18n"
      />

      <div class="submitted-edit-group">
        <mat-slide-toggle [(ngModel)]="allowEditSubmittedRows" color="primary">
          <span class="label-with-help">
            <span>{{ 'allow_edit_submitted_rows_label' | i18n }}</span>
            <mat-icon
              class="label-help-icon"
              [matTooltip]="'allow_edit_submitted_rows_note' | i18n"
              matTooltipPosition="above"
            >info</mat-icon>
          </span>
        </mat-slide-toggle>
      </div>

      <div class="block-future-dates-group">
        <mat-slide-toggle [(ngModel)]="blockFutureDates" color="primary">
          <span class="label-with-help">
            <span>{{ 'block_future_dates_label' | i18n }}</span>
            <mat-icon
              class="label-help-icon"
              [matTooltip]="'block_future_dates_note' | i18n"
              matTooltipPosition="above"
            >info</mat-icon>
          </span>
        </mat-slide-toggle>
      </div>

      <section class="config-section">
        <h3 class="section-title">{{ 'display_section_title' | i18n }}</h3>
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <mat-label class="label-with-help">
            <span>{{ 'display_timezone_label' | i18n }}</span>
            <mat-icon
              class="label-help-icon"
              [matTooltip]="'display_timezone_note' | i18n"
              matTooltipPosition="above"
            >info</mat-icon>
          </mat-label>
          <mat-select [(ngModel)]="displayTimezone">
            @for (option of timezoneOptions; track option) {
              <mat-option [value]="option">
                {{ ('timezone_' + timezoneKey(option)) | i18n }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </section>

      <section class="config-section">
        <h3 class="section-title">{{ 'ingestion_section_title' | i18n }}</h3>
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <mat-label class="label-with-help">
            <span>{{ 'import_export_timezone_label' | i18n }}</span>
            <mat-icon
              class="label-help-icon"
              [matTooltip]="'import_export_timezone_note' | i18n"
              matTooltipPosition="above"
            >info</mat-icon>
          </mat-label>
          <mat-select [(ngModel)]="timezone">
            @for (option of timezoneOptions; track option) {
              <mat-option [value]="option">
                {{ ('timezone_' + timezoneKey(option)) | i18n }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <mat-label>{{ 'timestamp_field_label' | i18n }}</mat-label>
          <input
            matInput
            [(ngModel)]="timestampField"
            [placeholder]="'timestamp_field_placeholder' | i18n"
          />
        </mat-form-field>

        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <mat-label class="label-with-help">
            <span>{{ 'duplicate_handling_label' | i18n }}</span>
            <mat-icon
              class="label-help-icon"
              [matTooltip]="'duplicate_handling_note' | i18n"
              matTooltipPosition="above"
            >info</mat-icon>
          </mat-label>
          <mat-select [(ngModel)]="duplicateHandling">
            @for (option of duplicateHandlingOptions; track option) {
              <mat-option [value]="option">
                {{ ('duplicate_handling_' + option) | i18n }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>

        <div class="period-group">
          <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <mat-label class="label-with-help">
              <span>{{ 'period_label' | i18n }}</span>
              <mat-icon
                class="label-help-icon"
                [matTooltip]="'period_behavior_note' | i18n"
                matTooltipPosition="above"
              >info</mat-icon>
            </mat-label>
            <mat-select [(ngModel)]="period">
              @for (option of periodOptions; track option) {
                <mat-option [value]="option">
                  {{ ('period_' + option) | i18n }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      </section>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions>
    <button type="button" mat-icon-button class="delete-btn" (click)="requestDelete()">
      <mat-icon>delete</mat-icon>
    </button>
    <span class="actions-spacer"></span>
    <button type="button" mat-button (click)="cancel()">
      {{ 'cancel' | i18n }}
    </button>
    <button
      type="button"
      mat-flat-button
      color="primary"
      [disabled]="!isValid"
      (click)="apply()"
    >
      {{ 'save' | i18n }}
    </button>
  </mat-dialog-actions>
</ng-container>
